<template>
  <div>
    <el-dialog
      title="年度业绩信息"
      :visible="add"
      width="540px"
      @close="closeBtn"
      :close-on-click-modal="false"
    >
      <div v-if="!detailShow">
        <el-form
          label-position="top"
          :model="skk_data"
          ref="form"
          label-width="120px"
          class="formTotal"
        >
          <el-row>
            <el-col :span="10">
              <el-form-item label="项目名称" prop="name">
                <el-input
                  v-model="skk_data.name"
                  placeholder="请输入项目名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row style="display: flex; align-items: flex-start">
            <el-col :span="10">
              <el-form-item label="项目类型" prop="type">
                <el-input
                  v-model="skk_data.type"
                  placeholder="请输入项目类型"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-row>
              <!--              {{ skk_time }}-->
              <el-col :span="10" style="margin-top: 20px">
                <el-form-item label="项目起止日期" prop="skk_time">
                  <el-date-picker
                    v-model="skk_time"
                    type="daterange"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="10" style="margin-top: 20px">
                <el-form-item label="委托单位名称" prop="company">
                  <el-input
                    v-model="skk_data.company"
                    placeholder="请输入委托单位名称"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-form-item label="承接业务专业" prop="service">
                <el-cascader
                  v-model="skk_data.service"
                  :options="options"
                  :props="{ expandTrigger: 'hover' }"
                  @change="handleChange"
                ></el-cascader>
              </el-form-item>
            </el-row>

            <el-row>
              <el-col :span="10" style="margin-top: 20px">
                <el-form-item label="项目造价/投资金额（万）" prop="amount">
                  <el-input
                    type="number"
                    v-model="skk_data.amount"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="10">
                <el-form-item label="收费比例" prop="ratio">
                  <el-input
                    v-model="skk_data.ratio"
                    placeholder="请输入收费比例"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="收费金额（万）" prop="money">
                <el-input
                  type="number"
                  v-model="skk_data.money"
                  placeholder="请输入金额"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-form-item label="收费时间" prop="money_time">
              <el-col :span="24">
                <el-date-picker
                  v-model="skk_data.money_time"
                  type="date"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-col>
            </el-form-item>
          </el-row>

          <el-row style="margin-top: 20px">
            <el-col :span="10">
              <el-form-item label="发票号码" prop="bill_code">
                <el-input
                  v-model="skk_data.bill_code"
                  placeholder="请输入发票号码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="项目负责人" prop="technical_name">
                <el-input
                  v-model="skk_data.technical_name"
                  placeholder="请输入项目负责人"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="项目负责人联系电话" prop="technical_tel">
                <el-input
                  v-model="skk_data.technical_tel"
                  placeholder="请输入项目负责人联系电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div v-else>
        <div class="contControll">
          <div class="them"></div>
          <div class="cont">
            <div class="item">
              <div class="text">项目名称</div>
              <div class="detail">
                {{ line_data.name ? line_data.name : "--" }}
              </div>
            </div>
            <div class="item">
              <div class="text">项目类型</div>
              <div class="detail">
                {{ line_data.type ? line_data.type : "--" }}
              </div>
            </div>

            <div class="item">
              <div class="text">项目起止日期</div>
              <div class="detail">
                {{ line_data.start_time }}至{{ line_data.finish_time }}
              </div>
            </div>
            <div class="item">
              <div class="text">委托单位名称</div>
              <div class="detail">
                {{ line_data.company ? line_data.company : "--" }}
              </div>
            </div>
            <div class="item">
              <div class="text">承接业务专业</div>
              <div class="detail">
                {{ line_data.service1 }}{{ line_data.service2 }}
              </div>
            </div>
            <div class="item">
              <div class="text">项目造价/投资金额（万）</div>
              <div class="detail">
                {{ line_data.amount ? line_data.amount : "--" }}
              </div>
            </div>
            <div class="item">
              <div class="text">收费比例</div>
              <div class="detail">
                {{ line_data.ratio ? line_data.ratio : "--" }}
              </div>
            </div>
            <div class="item">
              <div class="text">收费金额（万）</div>
              <div class="detail">
                {{ line_data.money ? line_data.money : "--" }}
              </div>
            </div>
            <div class="item">
              <div class="text">收费时间</div>
              <div class="detail">
                {{ line_data.money_time ? line_data.money_time : "--" }}
              </div>
            </div>
            <div class="item">
              <div class="text">发票号码</div>
              <div class="detail">
                {{ line_data.bill_code ? line_data.bill_code : "--" }}
              </div>
            </div>
            <div class="item">
              <div class="text">项目负责人</div>
              <div class="detail">
                {{ line_data.technical_name ? line_data.technical_name : "--" }}
              </div>
            </div>
            <div class="item">
              <div class="text">项目负责人联系电话</div>
              <div class="detail">
                {{ line_data.technical_tel ? line_data.technical_tel : "--" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div v-if="!detailShow">
          <el-button type="primary" @click="save_line">
            <!--            <template v-if="idx"> 确定添加 </template>-->
            <template> 保 存 </template>
          </el-button>
        </div>
        <!--        查看详情确定按钮-->
        <div v-else>
          <el-button class="btnSure" @click="closeBtn()">确 定</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// let id = 0;
import { editEach } from "@/api/yj";
import { get_options } from "./options.js"; //业务类型
export default {
  name: "SkkCreatPer",
  props: {
    tableData: {
      type: Array,
    },
    add: {
      type: Boolean,
      default: false,
    },
    detailShow: {
      type: Boolean,
      default: false,
    },
    //索引
    idx: {
      type: Number,
      default: -1,
    },
    //每一行的id
    rowId: {
      type: Number,
      default: null,
    },
    //record_id，编辑接口要要
    recordId: {
      type: Number,
      default: null,
    },
    item: {
      type: Array,
      default: null,
    },
  },
  watch: {
    add(val) {
      if (val === true) {
        this.init();
      }
    },
    skk_time(val) {
      // console.log(val, "时间的值");
      this.skk_data.start_time = val[0];
      this.skk_data.finish_time = val[1];
    },
  },
  created() {
    this.init();
  },
  data() {
    return {
      options: [],
      skk_time: [],
      // 数据
      skk_data: {},
      table_data: [],
      finish: true, //是否全部填写完成
      error: false, //是否有报错
    };
  },
  methods: {
    // 初始化表格中的数据
    init() {
      this.options = get_options();
      this.table_data = this.tableData;
      //是否要编辑 展示老值
      if (this.idx !== -1) {
        let skk_data = this.tableData[this.idx];
        // 时间
        if (!skk_data.start_time) {
          // console.log("用户上次没选过");
          // console.log(skk_data.start_time, "用户上次没选过日期");
          // console.log(typeof skk_data.start_time, "用户上次没选过日期");
          this.skk_time = [];
        } else {
          this.skk_time = [skk_data.start_time, skk_data.finish_time];
        }
        // 三级下拉
        let tempArr = [];
        if (skk_data.service1) {
          tempArr.push(skk_data.service1);
        }
        if (skk_data.service2) {
          tempArr.push(skk_data.service2);
        }
        if (skk_data.service3) {
          tempArr.push(skk_data.service3);
        }
        skk_data.service = tempArr;
        this.skk_data = skk_data;
      } else {
        this.skk_time = [];
        this.$set(this.$data, "skk_data", {
          name: "",
          type: "",
          company: "",
          start_time: "",
          finish_time: "",
          service1: "",
          service2: "",
          service3: "",
          amount: "",
          ratio: "",
          money: "",
          money_time: "",
          bill_code: "",
          technical_name: "",
          technical_tel: "",
        });
      }
    },
    closeBtn() {
      //填写的信息有报错
      if (this.error) {
        console.log("表单里有报错的地方");
      }
      this.$emit("update:add", false);
      this.$emit("upPage");
    },
    save_line() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.idx !== -1) {
            //请求编辑接口，单条保存数据
            try {
              const res = await editEach({
                project: JSON.stringify(this.skk_data),
                id: this.rowId,
                record_id: this.recordId,
              });
              if (res.result && res.result == 9) {
                // console.log("excel过来的这条报错了");
                this.error = true;
                this.$message.error("该条填写出错！请重新填写后保存");
                return false;

                // if (this.skk_data.name) {
                //   this.$message.error(
                //     `第${index + 1}条，${item.name}项目填写出错！`
                //   );
                // } else {
                //   this.$message.error(`${index + 1}条填写出错！`);
                // }
              } else {
                //如果保存正确
                this.$set(this.table_data, this.idx, {
                  ...this.skk_data,
                });
                // console.log(this.table_data, "this.table_data------");
              }
            } catch (e) {
              //     //编辑报错
              //     console.log(e, "错误了");
            }
          } else {
            //新增的
            // console.log("88888");
            // console.log(this.skk_data, "this.skk_data");
            this.table_data.push({
              ...this.skk_data,
            });
          }
          // console.log("eeeeee---------------");
          // this.$emit("update:tableData", this.table_data); //更新父级的表格数据

          this.closeBtn();
        }
      });
    },
    handleChange(value) {
      if (value) {
        // console.log(value);
        this.skk_data.service1 = value[0];
        this.skk_data.service2 = value[1];
        if (value.length == 3) {
          this.skk_data.service3 = value[value.length - 1];
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.contControll {
  display: flex;
  align-items: flex-start;

  .them {
    min-width: 110px;
    font-size: 12px;
    font-weight: 700;
    color: #333333;
  }

  .cont {
    flex: 1;

    .item {
      display: flex;
      align-items: center;
      margin-top: 16px;

      &:first-child {
        margin-top: unset;
      }

      .text {
        font-size: 12px;
        color: #999999;
        width: 190px;
      }

      .detail {
        font-size: 12px;
        color: #333333;
      }

      .check {
        font-size: 12px;
        color: #4379f6;
        cursor: pointer;
      }
    }
  }
}

/deep/ .el-form--label-top .el-form-item__label {
  padding: unset;
  font-size: 12px;
  color: #666666;
}

/deep/ .el-form-item__label {
  line-height: unset;
}

/deep/ .el-input__inner {
  margin-top: 5px;
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #dddddd;
}

/deep/ .el-dialog__footer {
  background: #f5f5f5;
  height: 70px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px;
}

.dialog-footer {
  /deep/ .el-button--primary {
    width: 100px;
    background: #f39020;
  }

  /deep/ .el-button {
    padding: unset;
    width: 100px;
    height: 32px;
    border-radius: unset;
  }
}

.t {
  margin-top: 20px;
  font-size: 12px;
  color: #666666;
}

.mt5 {
  margin-top: 5px;
}

.btnSure {
  background: #f39020;
  color: #fff;
}
</style>
